export default "__VITE_ASSET__BGLM2$qY__"